/**
 * Maps the current dashboard pathname to a safe, minimal section label.
 * Informational only — never includes private page contents.
 */
const ROUTE_SECTION_MAP = [
  { match: (p) => p.startsWith("/quiz/create"), label: "Create Quiz", key: "create_quiz" },
  { match: (p) => p.startsWith("/quiz/questions"), label: "Question Bank", key: "question_bank" },
  { match: (p) => p.startsWith("/quiz/titles"), label: "Course Catalog", key: "my_titles" },
  { match: (p) => p.startsWith("/quiz/results"), label: "Results", key: "results" },
  { match: (p) => p.startsWith("/quiz/heatmap"), label: "Heat Map", key: "heatmap" },
  { match: (p) => p.startsWith("/quiz/insights"), label: "Quiz Insights", key: "quiz_insights" },
  {
    match: (p) => /^\/presentationMakerPage\/[^/]+/i.test(p),
    label: "Presentation Maker",
    key: "presentation_maker",
  },
  { match: (p) => p.startsWith("/presentation"), label: "Presentations", key: "presentations" },
  { match: (p) => p.startsWith("/microlab-copilot"), label: "Microlab Copilot", key: "copilot" },
  { match: (p) => p.startsWith("/my-library"), label: "My Library", key: "my_library" },
  { match: (p) => p.startsWith("/community"), label: "Community", key: "community" },
  { match: (p) => p.startsWith("/stats") || p === "/dashboard", label: "Dashboard Stats", key: "stats" },
  { match: (p) => p.startsWith("/professors"), label: "Professors", key: "professors" },
  { match: (p) => p.startsWith("/students"), label: "Students", key: "students" },
  { match: (p) => p.startsWith("/titles"), label: "Histology Titles", key: "histology" },
  { match: (p) => p.startsWith("/anatomyTitles"), label: "Anatomy Titles", key: "anatomy" },
  { match: (p) => p.startsWith("/embryologyTitles"), label: "Embryology Titles", key: "embryology" },
  { match: (p) => p.startsWith("/ai-history"), label: "AI History", key: "ai_history" },
  { match: (p) => p.startsWith("/histology"), label: "Histology", key: "histology_student" },
];

/**
 * @param {string} pathname
 * @returns {{ key: string, label: string, pathname: string }}
 */
export function getDashboardRouteContext(pathname = "") {
  const path = String(pathname || "");
  const found = ROUTE_SECTION_MAP.find((entry) => entry.match(path));
  const makerMatch = path.match(/^\/presentationMakerPage\/([^/]+)/i);
  const presentationId = makerMatch?.[1] || null;
  if (found) {
    return {
      key: found.key,
      label: found.label,
      pathname: path,
      presentationId,
    };
  }
  return {
    key: "dashboard",
    label: "Dashboard",
    pathname: path,
    presentationId: null,
  };
}
